import jwtDecode from 'jwt-decode';

function getJWT() {
    let access_token = null;
    access_token = window.localStorage.getItem('jwt');
    if (access_token) {
      return access_token;
    }

    return access_token;
  }

export function getAuth() {
    var access_token = getJWT();
    if (access_token && access_token !== '') {
      let model = jwtDecode(access_token);
      if (model.exp * 1000 >= new Date().getTime()) {
        return model;
      }
      return null;
    } else return null;
  }

 